import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo, useState } from 'react';

import { CreateJobParameters } from '../../../../../../typings/api/skymap/rest/v0/geodata';
import { SkyMapAxiosServiceFactory } from '../../../../services/axios/skymap-axios-service-factory';
import { useErrorHandling } from '../../../hooks/use-error-handling';

export const useGeodataCreateJobMutation = (onSuccess?: () => void) => {
  const { clearErrors: clearApiErrors, handleError, buildErrorList } = useErrorHandling();
  const errorList = useMemo(() => buildErrorList(), [buildErrorList]);
  const [jobCreated, setJobCreated] = useState(false);
  const resetJobCreated = useCallback(() => setJobCreated(false), [setJobCreated]);

  const mutation = useMutation({
    mutationFn: (params: CreateJobParameters) => {
      return SkyMapAxiosServiceFactory.instance.createGeodataServiceV0().createJob(params);
    },
    retry: false,
    networkMode: 'always',
    onSuccess: () => {
      setJobCreated(true);
      onSuccess?.();
    },
    onMutate: () => clearApiErrors(),
    onError: (err) => handleError(err),
  });

  return {
    createJob: mutation.mutate,
    createJobAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    jobCreated,
    resetJobCreated,
    errorList,
  };
};
